import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getShopInfoApi } from 'redux/api';
import { shopAction } from 'redux/slices/shopSlice';

function* getShopInfoSaga(action: PayloadAction<{ shop_id: number; appName: string }>) {
  const { shop_id, appName } = action.payload;

  try {
    const res: AxiosResponse = yield call(getShopInfoApi, shop_id, appName);
    const { data } = res;
    if (res.status == 200) {
      yield put(shopAction.getShopInfoSuccess(data));
    }
  } catch (error) {}
}

export default function* shopSaga() {
  yield takeLatest(shopAction.getShopInfo.type, getShopInfoSaga);
}
